import constants from "../../constants";
import React, { useContext } from "react";
import TestDueHooks from "../../Hooks/TestDueHooks";
import AlertContext from "../../context/AlertContext";

export default function StatusLabel(Props) {
  const Alert = useContext(AlertContext);

  const { currentDueLabel } = TestDueHooks();

  // let status = Alert.status;
  let status = Alert.testData.mockuse || Alert.isAdmin ? Props.status : Alert.status;
  // console.log("Alert.testData:",Alert.testData);
  
  
  return (
    <div
      className={
        Props.component === "rightMain"
          ? "codingStatusLabelForCodingRightMain"
          : Props.component === "codingTable"
          ? "codingStatusLabelForCodingTable"
          : "codingStatusLabel"
      }
    >
      {(currentDueLabel(Alert.testData.duedate) === "Past Due" &&
        status !== constants.PROGRESS_STATUS.EVALUATED &&
        status !== constants.PROGRESS_STATUS.TO_BE_EVALUATED &&
        status !== constants.PROGRESS_STATUS.PARTIAL_EVALUATED) ||
      status === constants.PROGRESS_STATUS.UNLOCKED ||
      status === constants.PROGRESS_STATUS.UNLOCKED ? (
        <span className="testPending">
          {!localStorage.getItem("mockLp") &&
          Alert.lpData.batchType !== constants.BATCH_TYPE.SELF &&
          currentDueLabel(Alert.testData.duedate) === "Past Due"
            ? currentDueLabel(Alert.testData.duedate)
            : "Pending"}
        </span>
      ) : (Props.component !== "codingTable" &&
          (status === constants.PROGRESS_STATUS.REATTEMPT ||
            status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION ||
            status === constants.PROGRESS_STATUS.IN_PROGRESS ||
            status === constants.PROGRESS_STATUS.QN_CONTINUE)) ||
        (Props.component === "codingTable" &&
          status === constants.PROGRESS_STATUS.QN_CONTINUE) ||
        status === constants.PROGRESS_STATUS.IN_PROGRESS ||
        status === constants.PROGRESS_STATUS.REATTEMPT ||
        status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION ? (
        <span className="testInProgress">
          {(Props.component === "rightMain" ||
            Props.component === "codingTable" ||
            status === constants.PROGRESS_STATUS.IN_PROGRESS) &&
            (Alert.isAdmin && (status === constants.PROGRESS_STATUS.REATTEMPT || status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION)
              ? "Resubmission"
              : Alert.isAdmin && status === constants.PROGRESS_STATUS.IN_PROGRESS
              ? "In Progress"
              : Alert.isAdmin && status === constants.PROGRESS_STATUS.QN_CONTINUE
              ? "Ongoing"
              : status === constants.PROGRESS_STATUS.REATTEMPT ||
                status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION ||
                status === constants.PROGRESS_STATUS.IN_PROGRESS ||
                status === constants.PROGRESS_STATUS.QN_CONTINUE
              ? "In Progress"
              : "Ongoing")}
        </span>
      ) : status === constants.PROGRESS_STATUS.REATTEMPT  ? (
        <span className="testEvaluated">Evaluated</span>
      ) : status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION ? (
        <span className="testEvaluated">Evaluated</span>
      ) : (
        <span className="testSubmitted">
          {status === constants.PROGRESS_STATUS.TO_BE_EVALUATED &&
          Alert.approveData.hasOwnProperty("actualscore") &&
          (Alert.approveData.actualscore === null ||
            Alert.approveData.actualscore === undefined)
            ? "To be evaluated"
            : "Submitted"}
        </span>
      )}
    </div>
  );
}
